import { render } from "./VideoLink.vue?vue&type=template&id=fadecb50&scoped=true"
import script from "./VideoLink.vue?vue&type=script&lang=ts"
export * from "./VideoLink.vue?vue&type=script&lang=ts"

import "./VideoLink.vue?vue&type=style&index=0&id=fadecb50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fadecb50"

export default script